var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1842,
    cy: 16.1842,
    r: 16.1842,
    fill: "#F5EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0466 10.0751C25.3211 10.3881 24.5317 10.6133 23.7185 10.701C24.5628 10.1994 25.195 9.40704 25.4966 8.47248C24.7043 8.94377 23.8365 9.27424 22.9314 9.44924C22.5532 9.04485 22.0957 8.7227 21.5875 8.50285C21.0793 8.283 20.5312 8.17017 19.9775 8.1714C17.7372 8.1714 15.9354 9.98741 15.9354 12.2159C15.9354 12.5289 15.9733 12.8418 16.035 13.1429C12.6804 12.9675 9.68851 11.3648 7.69947 8.91108C7.33704 9.53012 7.14712 10.235 7.14946 10.9523C7.14946 12.3558 7.86305 13.5934 8.95122 14.3212C8.30994 14.2959 7.68369 14.1197 7.12338 13.8067V13.8565C7.12338 15.8219 8.51263 17.4506 10.3642 17.8252C10.0165 17.9155 9.6589 17.9617 9.29971 17.9627C9.03656 17.9627 8.78764 17.9366 8.53634 17.901C9.04842 19.5037 10.5396 20.6677 12.3153 20.7057C10.926 21.7939 9.18592 22.434 7.29644 22.434C6.95743 22.434 6.64449 22.4221 6.3197 22.3842C8.11198 23.534 10.2385 24.1978 12.5287 24.1978C19.9633 24.1978 24.0315 18.0385 24.0315 12.6925C24.0315 12.517 24.0315 12.3416 24.0196 12.1661C24.8067 11.59 25.4966 10.8764 26.0466 10.0751Z",
    fill: "#3C1D59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b5220e2afb3410b12d97d7eef9e61467.svg";
export { ForwardRef as ReactComponent };